
import { useState, useEffect, useCallback } from 'react';

export const useSubscriptionDetails = (
  searchParams: URLSearchParams,
  setSearchParams: (params: URLSearchParams) => void
) => {
  // Всегда инициализируем все хуки, независимо от условий
  const [selectedSubscription, setSelectedSubscription] = useState<string | null>(null);
  const [showDetailsDialog, setShowDetailsDialog] = useState(false);

  // Инициализация на основе URL при монтировании компонента
  useEffect(() => {
    const id = searchParams.get('id');
    if (id) {
      setSelectedSubscription(id);
      setShowDetailsDialog(true);
    }
  }, []);

  const handleViewSubscription = useCallback((subscriptionId: string) => {
    setSelectedSubscription(subscriptionId);
    setShowDetailsDialog(true);
    // Обновляем URL для возможности прямого доступа
    const newParams = new URLSearchParams(searchParams);
    newParams.set('id', subscriptionId);
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  const handleCloseDialog = useCallback(() => {
    setShowDetailsDialog(false);
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('id');
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  return {
    selectedSubscription,
    showDetailsDialog,
    handleViewSubscription,
    handleCloseDialog
  };
};
